import { useState } from "react";
import { useParams } from "react-router-dom";

import Modal from "components/atoms/modal";
import { H2 } from "components/atoms/text";

import Palette from "components/layouts/Header/ModalPalette/Palette";
import Inquiry from "components/layouts/Header/ModalPalette/Inquiry";
import History from "components/layouts/Header/ModalPalette/History";

import PinIdInfo from "types/PinIdInfo";
import useProject from "apis/queries/project/useProject";

import { ReactComponent as IconClose } from "assets/images/common/close.svg";

interface Props {
  onClose: () => void;
}

type ModalType = "MyPalette" | "샘플문의" | "신청내역";

// 마이팔레트 모달
const ModalPalette = ({ onClose }: Props) => {
  const [modalType, setModalType] = useState<ModalType>("MyPalette");
  const [pinIdInfo, setPinIdInfo] = useState<PinIdInfo[]>([]);
  const params = useParams();

  // 씬의 핀 목록 api
  const projectId = Number(params.id);
  const { project } = useProject({ projectId });

  // 모달 닫기 버튼 이벤트
  const handleClose = () => {
    if (modalType === "MyPalette") {
      onClose();
    } else {
      setModalType("MyPalette");
    }
  };

  if (!project) return null;

  // 샘플신청 할 핀 목록
  const inquiryPins = project.scenes
    .map((scene) => scene.pins)
    .flat()
    .filter((pin) => !!pinIdInfo.find((info) => info.pinId === pin.id))
    .map((pin) => {
      const squareMeasure = pinIdInfo.find(
        (p) => p.pinId === pin.id
      )?.squareMeasure;
      return { ...pin, squareMeasure: Number(squareMeasure) };
    });

  return (
    <Modal.Large className="w-[1100px]">
      <button onClick={handleClose} className="absolute right-10 top-10">
        <IconClose />
      </button>

      <div className="flex-none">
        <H2 className="text-primary-active">
          {modalType} {modalType === "샘플문의" && `(${project.name})`}
        </H2>
      </div>

      {modalType === "MyPalette" && (
        <Palette
          onChangeTypeContact={() => setModalType("샘플문의")}
          onChangeTypeHistory={() => setModalType("신청내역")}
          pinIdInfo={pinIdInfo}
          onChnagePinIdInfo={(value) => setPinIdInfo(value)}
          projectId={projectId}
        />
      )}
      {modalType === "샘플문의" && (
        <Inquiry
          onClose={() => setModalType("MyPalette")}
          pinIdInfo={pinIdInfo}
          pins={inquiryPins}
          project={project}
        />
      )}
      {modalType === "신청내역" && <History />}
    </Modal.Large>
  );
};

export default ModalPalette;
